import React, {useMemo} from 'react';

// services
import {CreditBookApi} from '../../../shared/services/ApiService';

// helpers
import {useTranslation} from 'react-i18next';
import {useQuery} from '@tanstack/react-query';

// components
import {
  CardDetailsSkeleton,
  CardDetailsLoan,
  CardError,
} from '../../../shared/components';
import {CardNoActiveItem} from '../components';

// styles
import {IconLoan} from '../DashboardPage-styles';

// types
import {
  CreditBookApiError,
  Loan,
} from '../../../shared/services/ApiService/types';

/**
 * Fetch the loans
 */
const fetchLoans = async () => {
  const {data} = await CreditBookApi.loan.getLoansSummary();
  return data;
};

const SectionActiveLoans = () => {
  const {t} = useTranslation();

  const {
    data: loans = [],
    isLoading: loansLoading,
    error: loansError,
    isRefetching: loansRefetching,
  } = useQuery<Loan[], CreditBookApiError>({
    queryKey: ['getLoans'],
    queryFn: fetchLoans,
    initialData: [],
  });

  const inProgressLoans = useMemo(() => {
    return loans.filter((loan) => loan.statusCode === 'IP');
  }, [loans]);

  /**
   * Render the in-progress loans based on the state
   */
  const renderInProgressLoans = () => {
    if (loansLoading || loansRefetching) {
      return <CardDetailsSkeleton variant="summary" />;
    }

    if (loansError) {
      return (
        <CardError
          title={t('loan_loans')}
          message={loansError?.response?.data?.errorMessage}
        />
      );
    }

    if (inProgressLoans.length === 0) {
      return (
        <CardNoActiveItem
          title={t('dashboard_noActiveLoan')}
          icon={<IconLoan />}
          href="/loans"
        />
      );
    }

    return inProgressLoans.map((loan) => (
      <CardDetailsLoan key={loan.id} variant="summary" loan={loan} />
    ));
  };

  return <>{renderInProgressLoans()}</>;
};

export default SectionActiveLoans;
